<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <div className="animated">
            <b-card header-tag="header" footer-tag="footer">
              <h1>Ordenes de compra</h1>
              <div>
                <b-input-group prepend="Rango de fecha del pedido" class="mt-3">
                  <date-range-picker
                    ref="picker"
                    v-model="dateRange"
                    :locale-data="locale"
                    :ranges="ranges"
                    opens="right"
                    @update="updateValues"
                    :autoApply="autoApply"
                    :showWeekNumbers="showWeekNumbers"
                  >
                    <div slot="input" slot-scope="picker" style="min-width: 200px">
                      <i class="fa fa-calendar text-primary"></i>

                      {{ picker.startDate | date_format }} -
                      {{ picker.endDate | date_format }}
                    </div>
                  </date-range-picker>
                </b-input-group>
              </div>
              <hr />
              <v-server-table
                :url="url"
                :columns="columns"
                :options="options"
                :theme="theme"
                ref="table"
                id="dataTable"
              >
                <!-- <div slot="beforeLimit">
                  <download-excel
                    class="btn"
                    :fetch="fetchData"
                    :fields="json_fields2"
                    worksheet="Guias"
                    :name="name"
                    :before-generate="startDownload"
                    :before-finish="finishDownload">
                    <b-link>Descargar</b-link>
                  </download-excel>
                </div> -->

                <div class="text-left" slot="order_date" slot-scope="props">
                  {{ props.row.order_date | date_format }}
                </div>

                <div class="text-left" slot="delivery_date" slot-scope="props">
                  {{ props.row.delivery_date | date_format }}
                </div>

                <div class="text-center" slot="actions" slot-scope="props">
                  <a
                    title="Detalle"
                    href="#"
                    @click.prevent="reportModal(props.row)"
                    class="fa fa-lg fa-search text-black-50"
                  ></a
                  >&nbsp;
                </div>
              </v-server-table>
            </b-card>
          </div>
        </b-col>
      </b-row>
    </div>

    <b-modal ref="infoModal" centered size="xl" title="Detalle" @ok="purchaseOrderDetails = null" ok-only>
      <div class="text-center">
        <b-spinner v-if="!purchaseOrderDetails" label="Spinning"></b-spinner>
      </div>
      <Report
        v-if="purchaseOrderDetails"
        :purchaseOrderDetails="purchaseOrderDetails"
        :purchaseOrderData="purchaseOrderData"
      ></Report>
    </b-modal>
  </div>
</template>

<script>
import Vue from "vue";
import { ServerTable, Event } from "vue-tables-2";
import numeral from "numeral";
import locales from "numeral/locales";

import JsonExcel from "vue-json-excel";
import moment from "moment";
import Report from "./Report.vue";

import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/lib/vue-daterange-picker.min.css";

numeral.locale("es");
moment.locale("es");

Vue.component("downloadExcel", JsonExcel);

window.axios = require("axios");

Vue.use(ServerTable);
var d = new Date();

export default {
  name: "ListPurchaseOrder",
  components: {
    ServerTable,
    Report,
    DateRangePicker
  },
  mounted() {
    Event.$on("vue-tables.loading", () => {
      this.loading = true;
    });

    Event.$on("vue-tables.loaded", () => {
      this.loading = false;
    });
  },
  props: [],
  data() {
    return {
      form: {
        report: null,
        from: null,
        to: null
      },
      purchaseOrderData: null,
      purchaseOrderDetails: null,
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8"
          }
        ]
      ],
      json_fields: {
        Numero: "waybill"
      },
      columns: [
        //"id",
        "company",
        "number",
        "order_date",
        "delivery_date",
        "currency",
        // "note",
        "status",
        "actions"
      ],
      data: [],
      useVuex: false,
      theme: "bootstrap4",
      template: "default",
      options: {
        responseAdapter: function (resp) {
          const results = resp.data.results;
          const items = [];
          for (let key in results) {
            const item = results[key];
            items.push(item);
          }

          return {
            data: items,
            count: resp.data.count
          };
        },
        texts: {
          noResults: "No se encontraron registros.",
          filter: "Filtrar:",
          filterBy: "Filtrar por {column}",
          count: " ",
          filterPlaceholder: "Buscar...",
          columns: "Columnas",
          limit: "Registros:"
        },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        debounce: 700,
        // columnsDropdown: true,
        filterByColumn: true,
        filterable: ["company", "number"],
        headings: {
          //id: "id",
          company: "Proveedor",
          number: "Numero orden de compra",
          order_date: "Fecha del pedido",
          delivery_date: "Fecha de entrega",
          currency: "Moneda",
          //note: "Nota",
          status: "Estado",
          actions: "Acciones"
        },
        sortable: [],
        sortIcon: {
          base: "fa",
          up: "fa-sort-asc",
          down: "fa-sort-desc",
          is: "fa-sort"
        },
        pagination: {
          dropdown: false,
          chunk: 10
        }
      },
      json_fields2: {
        Numero: "waybill.number",
        Embarque: "shipment.boarding_number",
        Vgm: {
          field: "vgm",
          callback: (value) => {
            return numeral(parseFloat(value)).format("0.00");
          }
        },
        "Planilla SAG": "sag_sheet",
        "Contraparte SAG": "sag_worker.get_full_name"
      },
      dateRange: null,
      startDate: new Date() - 7,
      endDate: new Date(),
      locale: {
        direction: "ltr", //direction of text
        format: "DD-MM-YYYY", //fomart of the dates displayed
        separator: " - ", //separator between the two ranges
        applyLabel: "Ok",
        cancelLabel: "Cancelar",
        weekLabel: "S",
        customRangeLabel: "Custom Range",
        daysOfWeek: moment.weekdaysMin(), //array of days - see moment documenations for details
        monthNames: moment.monthsShort(), //array of month names - see moment documenations for details
        firstDay: 1 //ISO first day of week - see moment documenations for details
      },
      ranges: {
        // 'Hoy': [moment(), moment()],
        // 'Ayer': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
        "Este mes": [moment().startOf("month"), moment().endOf("month")],
        "1ra Quincena": [moment().startOf("month"), moment().startOf("month").add(14, "days")],
        "2da Quincena": [moment().startOf("month").add(15, "days"), moment().endOf("month")],
        "Este año": [moment().startOf("year"), moment().endOf("year")],
        "Semana Pasada": [moment().subtract(1, "week").startOf("week"), moment().subtract(1, "week").endOf("week")],
        "Mes pasado": [moment().subtract(1, "month").startOf("month"), moment().subtract(1, "month").endOf("month")]
      },
      showWeekNumbers: true,
      autoApply: true
    };
  },
  filters: {
    date_format(value) {
      return moment(value).format("DD-MM-YYYY");
    }
  },
  computed: {
    url() {
      return "/api/v1/current-purchase-order/?" + "&startDate=" + this.form.from + "&endDate=" + this.form.to;
    },
    name() {
      return "GuiasExportacion " + moment(Date.now()).format("YYYYMMDD h:mm") + ".xls";
    }
  },
  methods: {
    updateValues(a) {
      this.form.from = moment(a.startDate).format("YYYY-MM-DD");
      this.form.to = moment(a.endDate).format("YYYY-MM-DD");
    },
    closeModal() {
      this.$refs.modalEstiba.hide();
    },
    reportModal(row) {
      this.$refs.infoModal.show();
      this.purchaseOrderData = row;
      this.$axios
        .get("/api/supplies/purchase-order/report_detail/?" + "id=" + row.id)
        .then((res) => {
          this.purchaseOrderDetails = res.data.data;
        })
        .catch((error) => console.log(error));
    },
    async fetchData() {
      const response = await this.$axios.get("/api/comex/export_waybill/detailed/");

      return response.data.results;
    },
    startDownload() {
      this.loading = true;
    },
    finishDownload() {
      this.loading = false;
    },

    forceFileDownload(response, a) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Packing List - Guia #" + a + ".xlsx"); //or any other extension
      document.body.appendChild(link);
      link.click();
    },

    downloadWithAxios(a, b) {
      this.$axios({
        method: "get",
        url: "/api/comex/export_waybill/" + a + "/packing_list/",
        responseType: "arraybuffer"
      })
        .then((response) => {
          this.forceFileDownload(response, b);
        })
        .catch(() => console.log("error occured"));
    },
    status(shipment_status) {
      return shipment_status === 2 ? "DESPACHADO" : "ABIERTO";
    },
    getBadge(shipment_status) {
      return shipment_status === 2 ? "dark" : "light";
    },

    edit(row) {},
    onComplete() {}
  },
  beforeMount() {}
};
</script>

<style>
#dataTable {
  width: 100%;
  margin: 0 auto;

  .VuePagination {
    text-align: center;
    justify-content: center;
  }

  .table td {
    padding: 0.3em;
  }

  .vue-title {
    text-align: center;
    margin-bottom: 10px;
  }

  .VueTables__search-field {
    display: flex;
  }

  .VueTables__search-field input {
    margin-left: 0.12rem;
  }

  .VueTables__limit-field {
    display: flex;
  }

  .VueTables__limit-field select {
    margin-left: 0.25rem !important;
  }

  .VueTables__table th {
    text-align: center;
    padding: 0.25rem;
  }

  .VueTables__child-row-toggler {
    width: 16px;
    height: 16px;
    line-height: 16px;
    display: block;
    margin: auto;
    text-align: center;
  }

  .VueTables__child-row-toggler--closed::before {
    content: "+";
  }

  .VueTables__date-filter {
    border: 1px solid #ccc;
    padding: 6px;
    border-radius: 4px;
    cursor: pointer;
  }

  .VueTables__number-field {
    border: 4px solid #ccc;
    padding: 6px;
    border-radius: 4px;
    cursor: pointer;
  }

  .VueTables__child-row-toggler--open::before {
    content: "-";
  }
}
</style>
